// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyChXJmkoFgfoPKzuVdFH00rwXQHytsoqGk",
  authDomain: "bornxbobbysitelogin.firebaseapp.com",
  projectId: "bornxbobbysitelogin",
  storageBucket: "bornxbobbysitelogin.appspot.com",
  messagingSenderId: "827608957628",
  appId: "1:827608957628:web:a080254666814e269bc6b9",
  measurementId: "G-FRXBHP1LXT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const fire = getAnalytics(app);

export default app;